import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3800929241/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
